<div style="position: relative;">
  <div class="dowload_loader" *ngIf="downloadFlag">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div style="margin-top: 15px; font-weight: 500;">Please wait while downloading...</div>
  </div>
  <div>
    <div>
      <div mat-dialog-content class="dilog_main_div_wrapper">
        <div class="chart_header_main_div">
          <div class="chart_header_logo_div">
            <img src="../../../assets/img/Foodbud_name_in_grey.svg" alt="" style="width: 40px;">
          </div>
          <div class="col-md-4">
            <div class="col-md-12 col-sm-6" class="paddbottom3">
              <label for="food_dishes_name" class="fnt-wght">Categories</label>
              <ng-select [(ngModel)]="food_dishes_category_id" name="food_dishes_category_id" [items]="categories"
                bindLabel="dish_type_name" bindValue="dish_type_id" [virtualScroll]="true" placeholder="Categories"
                (change)="categoriesChangeHandler()" [clearable]="false">
              </ng-select>
            </div>
          </div>
          <div class="chart_header_info_div">
            You can find this template, including more information at <a href="https://www.food.gov.uk/aalergy-guidance"
              target="_blank">
              www.food.gov.uk/aalergy-guidance
            </a>
          </div>
        </div>

        <div class="chart_main_table_div" #content>
          <!-- <div class="hiden_element_for_download">
            <div style="display: flex;justify-content: space-between;margin-bottom: 5px;">
              <div class="chart_header_logo_div">
                <img src="../../../assets/img/Foodbud_name_in_grey.svg" alt="" style="width: 40px;">
              </div>
              <div class="chart_header_info_div">
                You can find this template, including more information at <a
                  href="https://www.food.gov.uk/aalergy-guidance" target="_blank">
                  www.food.gov.uk/aalergy-guidance
                </a>
              </div>
            </div>

          </div> -->
          <table class="dataframe myfavourite_table" id="table_allergen">
            <thead>
              <tr style="text-align: right;">
                <th class="dishes_const_text">Dishes</th>
                <ng-container *ngFor="let item of allergensData">
                  <th>{{item.allergens_name}}</th>
                </ng-container>
              </tr>
              <tr>
                <td class="dishes_const_text">&nbsp;</td>
                <ng-container *ngFor="let item of allergensData">
                  <td style="min-width: 50px;"><img [src]="item.image" alt="img"></td>
                </ng-container>

              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of dishesData">
                <tr>
                  <td class="dish_name_td">{{item.name}}</td>
                  <ng-container *ngFor="let allergens of allergensData">
                    <td *ngIf="allergensExist(item.allergens,allergens);else emptyTd">
                      <img src="../../../assets/img/allegen_icons_check-mark.svg" alt="">
                      <span *ngIf="getOptionAvailabel(item.allergens,allergens)"
                        style="margin-top: 5px;display: inline-block;font-size: 10px;">(O/A)</span>
                    </td>
                    <ng-template #emptyTd>
                      <td>&nbsp;</td>
                    </ng-template>

                  </ng-container>

                </tr>
              </ng-container>
            </tbody>
          </table>
          <!-- <div class="">
            <div class="note_msg_div">Note:- (O/A) indicates Option Available</div>
            <div class="reviewed_dtls_main_div">
              <div>
                <div class="reviewed_heading">Review Date:</div>
                <div class="reviewed_dtls">{{formatDate(reviewedBy[0].reviewed_date)}}</div>
              </div>
              <div>
                <div class="reviewed_heading">Reviewed By:</div>
                <div class="reviewed_dtls">{{reviewedBy[0].reviewed_by ? reviewedBy[0].reviewed_by : 'N/A'}}</div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="note_msg_div">Note:- (O/A) indicates Option Available</div>
        <div class="reviewed_dtls_main_div">
          <div>
            <div class="reviewed_heading">Review Date:</div>
            <div class="reviewed_dtls">{{formatDate(reviewedBy[0].reviewed_date)}}</div>
          </div>
          <div>
            <div class="reviewed_heading">Reviewed By:</div>
            <div class="reviewed_dtls">{{reviewedBy[0].reviewed_by ? reviewedBy[0].reviewed_by : 'N/A'}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="display: flex; justify-content: space-around; margin-top: 15px;gap: 15px;">
    <button type="button" class="btn btn-outline-primary" (click)="openReviewInfoDialog()">Update Review Info</button>
    <button type="button" class="btn btn-outline-primary" (click)="downloadPdf()">Download PDF</button>
  </div>
</div>


<style>
  .dilog_main_div_wrapper {
    display: flex;
    flex-direction: column;
    max-height: 80vh;
  }

  .chart_main_table_div {
    overflow-y: auto;
    overflow-x: auto;
    /* max-width: 380px; */
  }

  .chart_main_table_div::-webkit-scrollbar {
    display: block !important;
  }

  /* Optional: Style the scrollbars to the default look */
  .chart_main_table_div::-webkit-scrollbar-track {
    box-shadow: inset 0 0 2px rgba(#000, .1);
  }

  .chart_main_table_div::-webkit-scrollbar {
    background: rgba(#fff, .2);
    position: absolute;
    width: 2px;
  }

  .chart_main_table_div::-webkit-scrollbar:hover {
    display: block;
  }

  .chart_main_table_div::-webkit-scrollbar-thumb {
    background-color: main-palette(100);
  }

  .chart_main_table_div::-webkit-scrollbar:horizontal {
    height: 10px;
  }

  .chart_main_table_div::-webkit-scrollbar-thumb:vertical {
    background-color: #1BACDB;
    border-radius: 10px;
  }

  .chart_main_table_div::-webkit-scrollbar:vertical {
    width: 5px;

  }

  .cdk-overlay-pane {
    max-width: 350px !important;
  }

  .mat-dialog-container {
    padding: 10px !important;
  }

  .chart_header_main_div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .chart_header_logo_div {
    width: 30%;
  }

  .chart_header_info_div {
    /* width: 49%; */
    font-size: 10px;
  }

  .rotate_div {
    transform: rotate(-90deg);
  }





  .dishes_const_text {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    vertical-align: bottom;
    padding-bottom: 10px;
    padding-left: 5px;
    position: sticky;
    left: 0;
    background: white;
    z-index: 3;
  }






  .myfavourite_table {
    font-size: 9pt;
    font-family: Arial;
    border-collapse: separate;
    border: 1px solid silver;
    border-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    margin-bottom: 10px;
  }

  .myfavourite_table tr th,
  .myfavourite_table tr td {
    border: 1px solid silver;
  }

  .myfavourite_table thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 2;
  }

  .myfavourite_table tbody .dish_name_td {
    position: sticky;
    left: 0;
    background-color: white;
    z-index: 1;
    white-space: nowrap;
    text-align: left;
  }

  .myfavourite_table th:not(:nth-child(1)) {
    writing-mode: vertical-rl;
    padding: 0;
    margin: 0;
    font-size: 8pt;
    transform: scale(-1);
    padding: 0.25em 1em;
    line-height: 0.5;
    vertical-align: top;
    text-align: left;
    vertical-align: middle;
    padding-top: 10px;
    padding-bottom: 25px;
    font-weight: 500;
  }

  .myfavourite_table td {
    padding: 0.8em;
  }

  .note_msg_div {
    text-align: end;
    font-size: 12px;
  }

  .reviewed_dtls_main_div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 10px;
  }

  .reviewed_heading {
    font-size: 12px;
    font-weight: 300;
  }

  .reviewed_dtls {
    font-weight: 500;
    font-size: 13px;
  }

  .pdf-export .myfavourite_table th:not(:nth-child(1)) {
    /* Simplified CSS for PDF export */
    writing-mode: horizontal-tb;
    /* or any other simpler mode */
    transform: none;
    padding: 0.25em 1em;
    font-size: 10pt;
    /* Adjust as needed */
    text-align: center;
    /* Adjust as needed */
    vertical-align: middle;
  }

  .pdf-export .myfavourite_table tbody .dish_name_td {
    white-space: wrap;
  }

  .hiden_element_for_download {
    display: none;
    visibility: hidden;
  }

  .pdf-export .hiden_element_for_download {
    display: block;
    visibility: visible;
  }





  /* Spiner for download  */
  .dowload_loader {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 11111111;
    background: white;
    flex-direction: column;
  }



  .lds-ellipsis,
  .lds-ellipsis div {
    box-sizing: border-box;
  }

  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }

  .lds-ellipsis div {
    position: absolute;
    top: 33.33333px;
    width: 13.33333px;
    height: 13.33333px;
    border-radius: 50%;
    background: currentColor;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }

  .lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }

  .lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }

  .lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }

  .lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }

  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(0);
    }
  }

  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }

    100% {
      transform: translate(24px, 0);
    }
  }
</style>